import React, { useRef, useState, useEffect} from "react";
import DefaultHideIcon from '../assets/icons/dropdown-icon-default.svg';
import ActiveHideIcon from '../assets/icons/dropdown-icon-active.svg';
import HoverHideIcon from '../assets/icons/dropdown-icon-hover.svg';
import CloseDefaultIcon from  '../assets/icons/Close-gray.svg';
import CloseHoverIcon from  '../assets/icons/Close-white.svg';
import CloseActiveIcon from  '../assets/icons/Close-black.svg';
import Form from './Form';

const AdvanceMode = ({forms, setForms, isAdvOpen, setIsAdvOpen, textareaRef, addDepsRef, errorsRef, setErrorsActivated, displayErrors, scrollToTarget}) => {
  const [removed, setRemoved] = useState(false);
  
  const handleAddDependency = () => {
    if (displayErrors() === null) /*has no errors/empty dependency*/ {
      setForms(prev => {
        return [...prev, 
        {
          type: 'dependency',
          id: (forms.length - 1),
          selectedOpt: '',
          description: '',
          uuid: '',
          version: ''
        }];
      });
      if (addDepsRef && addDepsRef.current) {
        addDepsRef.current.classList.add('add-dependency-btn');
        addDepsRef.current.innerHTML = `
        <div class="mc-button mc-btn-wh">
          <div class="mc-btn-con">
            <p>+</p>
          </div>
        </div>`;
        // addDepsRef.current.innerHTML = '<p>+</p>';
      }
      setErrorsActivated(false);
    } else {
      setErrorsActivated(true);
      scrollToTarget(errorsRef);
    }
    textareaRef.current.value = '';
  };
  
  const handleOffAdvanceMode = () => {
    //for hide icon
    textareaRef.current.value = '';
    setForms([forms[0], {
        id: 'm',
        type: 'metadata',
        name: '',
        link: ''
      }]);
      if (addDepsRef && addDepsRef.current) {
      addDepsRef.current.classList.remove('add-dependency-btn');
      addDepsRef.current.innerHTML = `
        <div class="mc-button mc-btn-wh">
          <div class="mc-btn-con">
            <p>Create Dependency</p>
          </div>
        </div>`;
      }  
    setIsAdvOpen(!isAdvOpen);
  };
  
  const handleRemoveDependency = (id) => {
    if (forms.length === 3) /*only one dependency left*/ {
      if (addDepsRef && addDepsRef.current) {
      addDepsRef.current.classList.remove('add-dependency-btn');
      addDepsRef.current.innerHTML = `
        <div class="mc-button mc-btn-wh">
          <div class="mc-btn-con">
            <p>Create Dependency</p>
          </div>
        </div>`;
      }
    }
    const filtered = forms.filter((form) => form.id !== id);
    setForms(filtered);
};

useEffect(() => {
  //update dependency id when one has been removed
  const updatedForms = forms.map((form, index) => {
    return form.type === 'dependency' ?
    {...form, id: (index - 1).toString()} : form
  });
  setForms(updatedForms);
}, [removed]);

  
  return (
    <section className={`container advance-mode ${isAdvOpen ? 'flex' : 'hidden'}`}>
      <div className="creator-info children-spacing">
        <p className="heading">Creator's Info (Metadata)</p>
        <Form id="m" type="metadata" textareaRef={textareaRef} forms={forms} setForms={setForms} />
      </div>
      
      <div className="dependency__wrapper children-spacing">
        {
          forms.map((form) => {
            if (form.type === 'dependency') {
              return (
                <div key={form.id} className="dependency children-spacing relative">
                  <p className="heading">{`Dependency [ ${form.id} ]`}</p>
                  <div className="closeDpnd absolute top-3 right-0" onClick={() => {
                   handleRemoveDependency(form.id)
                    setRemoved(!removed);
                  }}>
                    <img className="dpnd-gr w-5" src={CloseDefaultIcon} />
                    <img className="dpnd-wh w-5" src={CloseHoverIcon} />
                    <img className="dpnd-bl w-5" src={CloseActiveIcon} />
                  </div>
                  <Form id={form.id} type="dependency" forms={forms} setForms={setForms} textareaRef={textareaRef} />
                </div>
              );
            } else {
              return null; 
            }
          })
        }
      </div>
      
      <div className="button-container" ref={addDepsRef} type="button" onClick={() => {handleAddDependency()}}>
        <div className="mc-button mc-btn-wh">
          <div className="mc-btn-con">
            <p>Create Dependency</p>
          </div>
        </div>
      </div>
      
      <div className="hide-icon hover:bg-[#8e8e8e2b] active:bg-[#8e8e8e]" onClick={handleOffAdvanceMode}>
        <div>
          <img className="dropdown-hideicon-default group-hover:hidden group-active:hidden" src={DefaultHideIcon}/>
          <img className="dropdown-hideicon-active group-hover:hidden group-active:block" src={ActiveHideIcon}/>
          <img className="dropdown-hideicon-hover group-hover:block group-active:hidden" src={HoverHideIcon}/>
        </div>
      </div>
    </section>
  );
}

export default AdvanceMode;

